import { render, staticRenderFns } from "./Trendline.vue?vue&type=template&id=401f606a&scoped=true"
import script from "./Trendline.vue?vue&type=script&lang=js"
export * from "./Trendline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f606a",
  null
  
)

export default component.exports